let config_prod = {
  baseUrl: "https://damnextgen.smartliving.jio.com/v2/api",
  DateTimeFormat: "DD/MM/YYYY hh:mm:ss A",
};
let config_dev = {
  baseUrl: "https://devdam.smartliving.jio.com/v2/api",
  DateTimeFormat: "DD/MM/YYYY hh:mm:ss A",
};
let config_local = {
  baseUrl: "http://localhost:3001/v2/api",
  DateTimeFormat: "DD/MM/YYYY hh:mm:ss A",
};
let config_docker = {
  baseUrl: "http://10.159.108.243:3001/v2/api",
  DateTimeFormat: "DD/MM/YYYY hh:mm:ss A",
};

let config;
if (window.location.hostname === "localhost") {
  config = config_local;
} else if (window.location.hostname === "devdam.smartliving.jio.com") {
  config = config_dev;
} else if (window.location.hostname === "10.159.94.127") {
  config = config_docker;
} else {
  config = config_prod;
}
// window.location.hostname === "localhost" ? config_ : config_prod;

export default config;
